const getGsuiteExportType = (mimeType) => {
  const typeMaps = {
    'application/vnd.google-apps.document': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.google-apps.drawing': 'image/png',
    'application/vnd.google-apps.script': 'application/vnd.google-apps.script+json',
    'application/vnd.google-apps.spreadsheet': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.google-apps.presentation': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  };

  return typeMaps[mimeType] || mimeType;
};

const isGsuiteFile = (mimeType) => mimeType && mimeType.startsWith('application/vnd.google');

export const getGSuiteMimeType = (mimeType) => {
  if (isGsuiteFile(mimeType)) {
    return getGsuiteExportType(mimeType);
  }
  return mimeType;
};

export const getItemName = (item) => {
  const extensionMaps = {
    'application/vnd.google-apps.document': '.docx',
    'application/vnd.google-apps.drawing': '.png',
    'application/vnd.google-apps.script': '.json',
    'application/vnd.google-apps.spreadsheet': '.xlsx',
    'application/vnd.google-apps.presentation': '.pptx',
  };

  const extension = extensionMaps[item.mimeType];
  if (extension && item.name && !item.name.endsWith(extension)) {
    return item.name + extension;
  }

  return item.name ? item.name : '/';
};
